import styled from 'styled-components'

export const Section = styled.section`
  width: 100%;
  margin-top: 148px;
  padding: 0 18px;
  display: flex;
  justify-content: center;
  @media (max-width: 900px) {
    margin-top: 64px;
  }
`

export const Container = styled.div`
  width: 100%;
  max-width: 1400px;
  min-height: 206px;
  background: url(/assets/images/gradient_background.webp) center / cover
    no-repeat;
  box-shadow: 0px 0px 20px 3px var(--hover3, #7879f133);
  border-radius: 20px;
  display: flex;
  align-items: center;
  position: relative;
  padding: 18px;
  @media (max-width: 900px) {
    flex-direction: column;
    min-height: unset;
    padding: 32px 18px;
  }
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: stretch;
    padding: 24px 18px;
  }
`

export const ImgCol = styled.div`
  position: absolute;
  left: 132px;
  bottom: 0;
  display: flex;
  align-items: flex-end;
  @media (max-width: 1200px) {
    left: 32px;
  }
  @media (max-width: 900px) {
    position: static;
    align-items: center;
    justify-content: center;
    margin-bottom: 24px;
    order: 1;
  }
  @media (max-width: 600px) {
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    width: 200px;
    height: 182px;
    display: flex;
  }
`

export const Content = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    order: 2;
  }
  @media (max-width: 600px) {
    margin-bottom: 12px;
  }
`

export const Text = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 28px;
  line-height: 140%;
  letter-spacing: 0%;
  color: var(--blue6, #21105d);
  margin-left: 30px;
  margin-right: 30px;
  text-align: left;
  @media (max-width: 900px) {
    margin: 0 0 24px 0;
    text-align: center;
    font-size: 20px;
  }
  @media (max-width: 600px) {
    font-size: 18px;
    font-weight: 600;
    line-height: 140%;
    text-align: center;
    margin: 0 0 12px 0;
    br {
      display: none;
    }
  }
`

export const ButtonCol = styled.div`
  position: absolute;
  right: 144px;
  display: flex;
  align-items: center;
  height: 100%;
  @media (max-width: 1200px) {
    right: 32px;
  }
  @media (max-width: 900px) {
    position: static;
    margin-top: 24px;
    justify-content: center;
    width: 100%;
    order: 3;
  }
  @media (max-width: 600px) {
    margin: 0 auto 12px auto;
    display: flex;
    justify-content: center;
    width: 100%;
  }
`

export const CTAButton = styled.button`
  width: 222px;
  height: 64px;
  border-radius: 10px;
  padding: 16px;
  background: var(--orange3, #f88621);
  color: #fff;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 2%;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  &:hover {
    background: var(--orange2, #f2994a);
  }
  @media (max-width: 600px) {
    width: auto;
    height: auto;
    padding: 10px;
    font-size: 13px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: 0%;
    text-align: center;
  }
`
